var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!(_vm.path === '/mIndex') && !(_vm.path === '/mContact') 
    && !(_vm.path === '/mNav') && !(_vm.path === '/mLaw') 
    && !(_vm.path === '/mProject') && !(_vm.path === '/mItems')
    && !(_vm.path === '/mInformation') && !(_vm.path === '/mAboutour')
    && !(_vm.path === '/mTrain') && !(_vm.path === '/mNews')
    && !(_vm.path === '/mNewsDetail') && !(_vm.path === '/mContact')
    && !(_vm.path === '/mDouble') && !(_vm.path === '/mCopyright'))?_c('Header'):_vm._e(),_c('router-view'),(!(_vm.path === '/mIndex') && !(_vm.path === '/mContact')
     && !(_vm.path === '/mNav') && !(_vm.path === '/mLaw')
     && !(_vm.path === '/mProject') && !(_vm.path === '/mItems')
     && !(_vm.path === '/mInformation') && !(_vm.path === '/mAboutour')
     && !(_vm.path === '/mTrain') && !(_vm.path === '/mNews')
     && !(_vm.path === '/mNewsDetail') && !(_vm.path === '/mContact')
     && !(_vm.path === '/mDouble') && !(_vm.path === '/mCopyright'))?_c('Footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }